<app-table
module="tickets"
pageTitle="Elenco tickets"
newRecordUrl="tickets/ticket-edit/new"
editRecordUrl="tickets/ticket-edit/update/"
deleteRecordUrl="tickets/ticket_delete"
listUrl="tickets/tickets_listall"
nuovoLabel="Nuovo ticket"
[listParams]="{}"></app-table>
